import { createCustomEnum } from "../customEnum";

const ChargebackReductionPlans = createCustomEnum({
	Requested: {
		value: 0,
		name: "requested",
		displayName: "Requested",
	},
	Received: {
		value: 1,
		name: "received",
		displayName: "Received",
	},
	Na: {
		value: 2,
		name: "na",
		displayName: "N/A",
	},
});
export default ChargebackReductionPlans;
